'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tracker = require('@ali/tracker');

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClueTracker = function () {
  function ClueTracker(opts) {
    _classCallCheck(this, ClueTracker);

    if (!opts.pid) {
      throw new Error('ClueTracker: pid must not be empty');
    }
    this._instance = new _tracker2.default({ pid: opts.pid });
  }

  _createClass(ClueTracker, [{
    key: 'onGlobalError',


    /**
     * 开启全局错误上报
     */
    value: function onGlobalError() {
      this._instance.onGlobalError();
    }

    /**
     * 自定义上报
     * @param {*} code code码
     * @param {*} msg 上报内容
     * @param {*} sampleRate 采样率
     */

  }, {
    key: 'log',
    value: function log(code, msg) {
      var sampleRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      this._instance.log({
        code: code, msg: msg, sampleRate: sampleRate
      });
    }
  }, {
    key: 'instance',
    get: function get() {
      return this._instance;
    }
  }]);

  return ClueTracker;
}();

exports.default = ClueTracker;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_alipic-utils@0.0.2@@ali/alipic-utils/lib/tracker.js
// module id = 267
// module chunks = 6